export function getFormattedContactInfo(value) {
  let contactMethod = 0;
  let contactId = value;
  if (value.indexOf('@') > -1) {
    contactMethod = 1;
  } else {
    contactId = contactId.replace(/\D/gi, '');
  }
  return {
    contactMethod,
    contactId,
  };
}

export const OTP_CONTACT_ID = 'otpContactId';
export const OTP_CONTACT_METHOD = 'otpContactMethod';
export const OTP_SEND_CODE_ERROR = 'otpSendCodeError';
export const OTP_LAYOUT_FACTORY_REF = 'otpLayoutFactoryRef';
export const PAGE_TEMPLATE_REF = 'template';
